import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { HttpErrorResponse } from '@angular/common/http';

import { ModuleConfiguration } from '../customer.module.config';

import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import { GroupService } from './GroupService';
import { GroupListModel } from '../models/GroupListModel';
import { AddGroupModel } from '../models/AddGroupModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { GroupModel } from '../models/GroupModel';
import { ModelResponse } from '../../core/services/ModelResponse';
import { ResponseMessage } from '../../core/services/ResponseMessage';
import { ResponseMessageType } from '../../core/services/ResponseMessageType';
import { LoadPagePayload } from '../../pillar/common/actions/LoadPagePayload';

@Injectable()
export class GroupServiceEffects {
  @Effect()
  getGroupList$: Observable<Action> = this.actions$.ofType(dashboardActions.getQueryListType<GroupListModel>(ModuleConfiguration.moduleName, GroupListModel))
    .map((a: dashboardActions.QueryListAction<GroupListModel>) => a.payload)
      .switchMap((payload: LoadPagePayload) => this.groupService.getGroupList(payload.page, payload.pageSize, payload.sort, payload.sortDirection, payload.searchTerm)
        .catch((error: HttpErrorResponse) => Observable.of(new QueryResponse<GroupListModel>(error)))
      .map((response: QueryResponse<GroupListModel>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, GroupListModel, { errors: response.messages.map(m => m.value) });
        }
        return new dashboardActions.QuerySuccessAction(ModuleConfiguration.moduleName, GroupListModel, { items: response.items, totalCount: response.totalCount });
      }));
  @Effect()
  getGroup$: Observable<Action> = this.actions$.ofType(dashboardActions.getSelectionType<GroupModel>(ModuleConfiguration.moduleName, GroupModel))
    .map((a: dashboardActions.GetSelectionAction<GroupModel>) => a.payload)
      .switchMap((payload: { key: string }) => this.groupService.getGroup(payload.key)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<GroupModel>(error)))
      .map((response: ModelResponse<GroupModel>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, GroupListModel, { errors: response.messages.map(m => m.value) });
        }
        return new dashboardActions.GetSelectionSuccessAction(ModuleConfiguration.moduleName, GroupModel, { model: response.model });
      }));
  @Effect()
  addGroup$: Observable<Action> = this.actions$.ofType(dashboardActions.addType<AddGroupModel>(ModuleConfiguration.moduleName, AddGroupModel))
    .map((a: dashboardActions.AddAction<AddGroupModel>) => a.payload)
      .switchMap((payload: { model: AddGroupModel }) => this.groupService.addGroup(payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<string>(error)))
      .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, GroupListModel, { errors: response.messages.map(m => m.value) });
        }
        return new dashboardActions.AddSuccessAction(ModuleConfiguration.moduleName, AddGroupModel, { key: response.model });
      }));
  @Effect()
  reviseName$: Observable<Action> = this.actions$.ofType(workspaceActions.updateModelType<GroupModel, string>(ModuleConfiguration.moduleName, GroupModel, 'name'))
    .switchMap((a: workspaceActions.UpdateModelAction<GroupModel, string>) => this.groupService.reviseName(a.payload.key, a.payload.model)
      .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new workspaceActions.UpdateModelErrorAction(
            {
              action: a,
              errors: response.messages.filter(m => m.type === ResponseMessageType.Error).map(m => m.value)
            });
        }
        return new workspaceActions.UpdateModelSuccessAction(ModuleConfiguration.moduleName,
          GroupModel,
          'name',
          {
            key: a.payload.key,
            model: response.model,
            control: a.payload.control
          });
      }));

  constructor(
    private groupService: GroupService,
    private actions$: Actions
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/customer/services/GroupService.effects.ts